import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import queryString from 'query-string'
import { createData, fruitsData } from '../../data/create'
import { batchDataProduct, batchDataRepack } from '../../data/batchData'
import TeamSelector from './Inputs/TeamSelector'
import { MainDataAdd } from './Inputs/MainDataAdd'
import { Create, Fruit } from '../../interfaces/interfaces'
import { MainData } from './Inputs/MainData'
import { ImageTemp, MainData as MainDataType } from '../../interfaces/intakes.reports'


import CreateButtonIntake from './CreateButtonIntake'
import { capitalize } from '../../helpers/eliminarEs'
import CreateButtonReport from './CreateButtonReport'
import CreateButtonRepack from './CreateButtonRepack'
import { repackData } from '../../data/repack'
import { RepackPrePost } from './Repack/RepackPrePost'
import { SupplierSelector } from './Inputs/SupplierSelector'
import { mainDataWithoutSupplier } from '../../helpers/mainDataConvert'
import { useTypedSelector } from '../../hooks/useTypedSelector'

interface QueryParams {
    fruit?: Fruit
    create?: Create
}

export const NewPage = () => {

    const navigate = useNavigate()
    const { id } = useParams<string>();

    const { fruit, create } = queryString.parse(id!) as QueryParams

    const { settings } = useTypedSelector(state => state.auth);

    const [team, setTeam] = useState<string | null>(null)
    const [preRepack, setPreRepack] = useState<MainDataType>(repackData)
    const [postRepack, setPostRepack] = useState<MainDataType>(repackData)
    const [mainData, setMainData] = useState<MainDataType | null>(null)
    const [supplierId, setSupplierId] = useState<string | null>(null)

    const [batchImages, setBatchImages] = useState<ImageTemp[]>([])

    useEffect(() => {
        if (!create || !fruit) navigate("/")
        if (!createData.includes(create as Create) || !fruitsData.includes(fruit as Fruit)) navigate("/")
    }, [fruit, create, navigate])

    useEffect(() => {
        create === "repack"
            ? setMainData(batchDataRepack(fruit as Fruit))
            : setMainData(batchDataProduct(fruit as Fruit, settings))
    }, [fruit, create])

    return (
        <div className="content intake">
            <main className="container">
                <h2 className="main-title mb-2">{capitalize(create)}</h2>
                <div className='mb-3'>
                    <TeamSelector setTeam={setTeam} team={team} />

                    {mainData &&
                        <SupplierSelector
                            team={team}
                            mainData={mainData as MainDataType}
                            setMainData={setMainData}
                            supplierId={supplierId}
                            setSupplier={setSupplierId}
                        />
                    }

                    <MainData
                        mainData={mainDataWithoutSupplier(mainData)}
                        setMainData={setMainData}
                        isList={false}
                    />

                    {
                        (create !== "repack" && mainData) &&
                        < MainDataAdd
                            mainData={mainData}
                            setMainData={setMainData}
                            isInitial={ create === "intake" ? false : true }
                            handleImages={(images) => setBatchImages(images)}
                            images={batchImages}
                        />
                    }
                </div>

                {
                    create === "repack" &&
                    <div className='mb-3 grid-query'>
                        <RepackPrePost
                            data={preRepack}
                            setData={setPreRepack}
                            type='pre'
                        />
                        <RepackPrePost
                            data={postRepack}
                            setData={setPostRepack}
                            type='post'
                        />
                    </div>
                }

                {
                    mainData &&
                    <>
                        {create === "intake" && <CreateButtonIntake mainData={mainData} team={team} />}
                        {create === "report" && <CreateButtonReport mainData={mainData} team={team} supplier={supplierId} fruit={fruit as Fruit} batchImages={batchImages}/>}
                        {create === "repack" && <CreateButtonRepack mainData={mainData} team={team} fruit={fruit as Fruit} preRepack={preRepack} postRepack={postRepack} />}
                    </>
                }

            </main>

        </div>
    )
}
